import React from 'react'
import { RadioContainer, RadioInner } from './styles'

interface CustomRadioProps {
  checked: boolean
  disabled?: boolean
  onClick?: () => void
}

const CustomRadio: React.FC<CustomRadioProps> = ({ checked, disabled = false, onClick }) => {
  const handleClick = () => {
    if (!disabled && onClick) {
      onClick()
    }
  }

  return (
    <RadioContainer disabled={disabled} onClick={handleClick}>
      <RadioInner checked={checked} disabled={disabled} />
    </RadioContainer>
  )
}

export default CustomRadio
